import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/tokens.css";
import "./styles/base.css";
import { WorkableSite } from "./App.tsx";

const root = document.getElementById("root");
if (!root) throw new Error("Application root element #root is missing");

createRoot(root).render(
  <StrictMode>
    <WorkableSite path={window.location.pathname} />
  </StrictMode>
);
